import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import {
  ConsumerSimSwapParams,
  ConsumerSimSwapResponse,
  GetConsumerIdentityPub,
  GetConsumerIdentitySimsPubResponse,
  GetCountryAddressConfigParams,
  GetCountryAddressConfigResponse,
  GetEndUsersParams,
  GetEndUsersResponse,
  UpdateEndUserParams,
  UpdateConsumerIdentityResponse,
  GetEndUserParams,
  GetEndUserResponse,
} from '../dtos';
import { ApiService } from '../../../../services/api.service';
import { ConsumerIdentityParam } from '../enums';
import { CustomHttpParamEncoder } from 'src/app/core/services';

@Injectable({
  providedIn: 'root',
})
export class ConsumersService {
  constructor(private readonly apiService: ApiService) {}

  /**
   * Get the consumer identity
   * @param consumerIdentityParam the sucriber id type
   * @param value the id value
   * permissions:[{mode: "+r", res: "consumerIdentity.*", dom: "consumerIdentity.consumerIdentityUuid.${consumerIdentityUuid}"}]
   */
  getConsumerIdentity(
    consumerIdentityParam: ConsumerIdentityParam,
    value: string,
    brandId?: string
  ): Observable<GetConsumerIdentityPub> {
    let params = new HttpParams();
    params = params.append(consumerIdentityParam, value);

    if (consumerIdentityParam === ConsumerIdentityParam.CURP && brandId) {
      params = params.append('brandId', brandId);
    }

    return this.apiService.get('/v1/consumers/consumer/identity', params);
  }

  /**
   *
   * @param endUserId
   * @param updateEndUserParams
   * permissions:[{mode: "+u", res: "consumerIdentity.*"}]
   */
  updateConsumerIdentity(
    endUserId: string,
    updateEndUserParams: UpdateEndUserParams
  ): Observable<UpdateConsumerIdentityResponse> {
    return this.apiService.put(
      `/v2/end-users/${endUserId}`,
      updateEndUserParams
    );
  }

  /**
   *
   * @param consumerIdentityUuid
   * @param getConsumerIdentitySimsParams
   * permissions:[{mode: "+r", res: "consumerIdentity.*"}]
   */
  getConsumerIdentitySimsPub(
    endUserId: string
  ): Observable<GetConsumerIdentitySimsPubResponse> {
    return this.apiService.get(`/v2/end-users/${endUserId}/sims`);
  }

  /**
   * Swap sim
   * @param endUserId
   * @param consumerSimSwapParams
   * permissions: {mode: "+u", res: "consumerIdentity.*"}
   */
  consumerSimSwap(
    endUserId: string,
    consumerSimSwapParams: ConsumerSimSwapParams
  ): Observable<ConsumerSimSwapResponse> {
    return this.apiService.post(
      `/v2/end-users/${endUserId}/sims/swap`,
      consumerSimSwapParams
    );
  }

  /**
   * Get End Users
   * @param getEndUsersParams
   * permissions: [{mode: "+r", res: "endUsers.*", dom: "[brandId]", tokenDom: "[brandUuid]"}]
   */
  getEndUsers(
    getEndUsersParams: GetEndUsersParams
  ): Observable<GetEndUsersResponse> {
    return this.apiService.post(
      '/v2-internal/end-users/search',
      getEndUsersParams
    );
  }

  getEndUser(
    consumerIdentityParam: ConsumerIdentityParam,
    value: string,
    brandId?: string
  ): Observable<GetEndUserResponse> {
    let params = new HttpParams({ encoder: new CustomHttpParamEncoder() });
    params = params.append(consumerIdentityParam, value);

    if (brandId) {
      params = params.append('brandId', brandId);
    }

    return this.apiService.get('/v2/end-users/end-user', params);
  }

  getCountryAddressConfig(
    getCountryAddressConfigParams: GetCountryAddressConfigParams
  ): Observable<GetCountryAddressConfigResponse> {
    let params: HttpParams = this.apiService.queryParams(
      getCountryAddressConfigParams
    );
    return this.apiService.get(`/v2-internal/end-users/info/config`, params);
  }
}
